import * as React from 'react';
import * as ReactSeparator from '@radix-ui/react-separator';
import { clsx } from 'clsx';

interface SeparatorProps extends React.ComponentPropsWithoutRef<typeof ReactSeparator.Root> {
  orientation?: 'horizontal' | 'vertical';
}

export const Separator = ({
  className = '',
  orientation = 'horizontal',
  ...props
}: SeparatorProps) => (
  <ReactSeparator.Root
    {...props}
    className={clsx(
      !className.includes('bg-') && 'bg-grey_border',
      orientation === 'horizontal' ? 'h-[1px]' : 'w-[1px]',
      className,
    )}
  />
);
